import axios from 'axios';
import store from '../store';
import router from '../router';
import api from '../api';

// Set base configuration using exported BASE_URL
axios.defaults.baseURL = api.BASE_URL;

// Request interceptor to add token to all requests
axios.interceptors.request.use(
  (config) => {
    const token = store.state.juryToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token is invalid or expired
      store.dispatch('logout');
      
      // Only redirect if not already on login page
      if (router.currentRoute.value.name !== 'JuryLogin') {
        router.push('/jury-login');
      }
    }
    return Promise.reject(error);
  }
);

export default axios;